/**
 * `unpriceable` 里除 `count` 外的每个 key 都是一种「成本事实未记录」的原因。
 *
 * 只有一种:`supplier_cost_not_recorded` —— 这一行没有保存供应商成本事实。禁止拿当前活价目
 * 回算历史调用，否则改价会追溯改写历史成本。
 */
const UNPRICEABLE_REASONS = ['supplier_cost_not_recorded']

/**
 * `unpriceable` → 真的发生了的那几种原因(条数为 0 的不显示,它没发生)。
 *
 * @param {{ count: number, supplier_cost_not_recorded: number }} unpriceable
 * @returns {Array<{ reason: string, count: number }>}
 */
export function unpriceableReasons(unpriceable) {
  const reasons = []
  for (const [key, count] of Object.entries(unpriceable)) {
    if (key === 'count') continue
    if (!UNPRICEABLE_REASONS.includes(key)) {
      throw new Error(`Unhandled unpriceable reason: ${key}`)
    }
    if (count > 0) reasons.push({ reason: key, count })
  }
  return reasons
}
